export default __webpack_public_path__ + "static/media/panel-specs-mobile.41fe2340.png";